package com.wintermar.inspection.core.ui.widget.menu

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.navigation.Route

@Composable
fun TopBarMenuContent(
    routeMenus: List<Route>,
    isMenuOpen: Boolean = false,
    paddingTop: Dp = LocalAppTheme.current.dimension.spacing.space0,
    onClick: (Route) -> Unit,
    onOpenMenu: () -> Unit
) {
    val dimension = LocalAppTheme.current.dimension

    Box {
        AnimatedVisibility(visible = isMenuOpen, enter = fadeIn(), exit = fadeOut()) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.5f))
                    .clickable(
                        enabled = !isMenuOpen,
                        onClick = { onOpenMenu() }
                    )
            )
        }
        AnimatedVisibility(
            visible = isMenuOpen,
            enter = slideInVertically { -it } + fadeIn(),
            exit = slideOutVertically { -it } + fadeOut()
        ) {
            LazyColumn(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(LocalAppTheme.current.color.surface.normal)
                    .padding(
                        top = paddingTop,
                        bottom = dimension.spacing.space4,
                    ),
                userScrollEnabled = false
            ) {
                items(routeMenus) {
                    TopBarItem(
                        route = it,
                        onClick = onClick
                    )
                }

                item {
                    HorizontalDivider(
                        modifier = Modifier.fillMaxWidth(),
                        color = LocalAppTheme.current.color.border.subtle
                    )
                }

                item {
                    TopBarItem(
                        route = Route.Logout,
                        onClick = onClick
                    )
                }
            }
        }
    }
}
